import { render } from "./updateHospitalInfo.vue?vue&type=template&id=289f43e5"
import script from "./updateHospitalInfo.vue?vue&type=script&lang=js"
export * from "./updateHospitalInfo.vue?vue&type=script&lang=js"

import "./updateHospitalInfo.vue?vue&type=style&index=0&id=289f43e5&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__